<template>
  <b-card>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols="2" sm="3" md="4" lg="4" xl="5"></b-col>
        <b-col cols="9" sm="7" md="6" lg="6" xl="5">
          <h3>Creacion de Productos</h3>
          <!-- <datepicker
                        v-model="femision"
                        :format="customFormatter"
                        :language="es"
                        :bootstrap-styling="true"
                        :disabledDates="diasnopermitidos"
                        :placeholder="currentdate"
                ></datepicker> -->
        </b-col>
        <b-col cols="1" sm="2" md="2" lg="2" xl="2"></b-col>
      </b-row>
    </div>
    <template>
      <div v-if="cargando" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Cargando...</strong>
      </div>
      <div v-else>
        <br />
        <b-container fluid>
          <b-row>
            <b-col sm="1" class="p-1">
              <div class="pt-1 h5">
                <b-badge>Buscar por:</b-badge>
              </div>
            </b-col>
            <b-col sm="1" class="p-1">
              <b-form-select class="p-1" v-model="parambus" slot="append">
                <option :value="'code'">Código</option>
                <option :value="'name'">Descripción</option>
                <option :value="'category'">Categoría</option>
              </b-form-select>
            </b-col>
            <b-col sm="3" class="p-1">
              <b-form-input
                placeholder="Ingresa tu busqueda"
                @change="searchProduct()"
                v-model="cadenabusqueda"
              ></b-form-input>
            </b-col>
            <b-col sm="2" class="p-1 m-0">
              <b-button variant="success" v-if="!cargandoproducto" @click="searchProduct()">
                Buscar
                <i class="fa fa-search"></i>
              </b-button>
              <b-button variant="secondary" v-else>
                <i class="fa fa-spin fa-spinner"></i>
              </b-button>
            </b-col>
            <b-col sm="1" class="p-0 m-0">
              <b-button variant="secondary" @click="listProduct">
                <i class="fa fa-sync-alt"></i>
              </b-button>
            </b-col>
            <br />
            <br />
            <b-col sm="1" class="p-0">
              <b-form-select v-model="orden" slot="append" @input="listProduct">
                <option :value="'asc'">Más Antiguo</option>
                <option :value="'desc'">Más Reciente</option>
              </b-form-select>
            </b-col>
            <b-col sm="1" class="p-0">
              <!-- <b-form-group horizontal label="Mostrar" class="mb-0 p-0"> -->
              <b-input-group>
                <b-form-select v-model="limite" @input="listProduct" slot="append">
                  <option :value="15">15</option>
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </b-form-select>
              </b-input-group>
              <!-- </b-form-group> -->
            </b-col>
            <b-col>
              <b-button 
                size="sm"
                variant="primary"
                @click="exportarStock()">
                Exportar Stock
              </b-button>
            </b-col>
          </b-row>
          <br />
          <template>
            <b-table responsive small :items="productos" :fields="productos_fields" outlined>
              <template slot="tipoAfectacionIgv" slot-scope="row">
                <span v-if="row.item.tipoAfectacionIgv == '01'">Gravado</span>
                <span v-else-if="row.item.tipoAfectacionIgv == '02'">Inafecto</span>
                <span v-else-if="row.item.tipoAfectacionIgv == '03'">Exonerado</span>
              </template>
              <template v-if="row.item && row.item.category && row.item.category !='' " slot="categoria" slot-scope="row">
                  <span >{{row.item.category.descripcion}}</span>
              </template>
              <template slot="stock" slot-scope="row">
                 <div v-if=" +row.item.stock < +row.item.stockMinimo" style="background-color:pink" class="text-center">
                   {{row.item.stock}}
                 </div>
                 <div v-else class="text-center">
                   {{row.item.stock}}
                 </div>
              </template>
              <template slot="stockMinimo" slot-scope="row">
                 <div class="text-center">
                    {{row.item.stockMinimo}}
                 </div>
              </template>
              <template slot="precioUnitario" slot-scope="row">
                 S/.{{Number.parseFloat(row.item.precioUnitario).toFixed(10)}}
              </template>
              <template slot="estadooc" slot-scope="row">
                <b-form-checkbox
                  v-model="row.item.ordenCompra"
                  @change="changeEstado(row.item)"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </template>
              <template slot="acciones" slot-scope="row">
                <b-button-group>
                  <b-btn
                    variant="primary"
                    size="sm"
                    @click.prevent="setUpdateProduct(row.item)"
                    v-b-modal.modal1
                    class="btn btn-sm btn-group"
                  >
                    <i class="fa fa-pencil-alt"></i>
                  </b-btn>
                  <b-button
                    variant="warning"
                    size="sm"
                    class="btn-group"
                    title="Kardex"
                    @click="infoProducto(row.item)">                   
                    <i class="nav-icon fa fa-boxes"></i>
                  </b-button>
                  <b-btn
                    size="sm"
                    variant="danger"
                    class="btn btn-sm btn-group"
                    @click.prevent="deleteProduct(row.item, row.index)"
                  >
                    <i class="fa fa-trash"></i>
                  </b-btn>
                </b-button-group>
              </template>
            </b-table>
          </template>
        </b-container>
        <b-row>
          <b-col cols="12" sm="4" md="6" lg="8" xl="8">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
          </b-col>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <b-pagination
              size="sm"
              :total-rows="total"
              v-model.number="pactual"
              @input="listProduct"
              :per-page="limite"
            ></b-pagination>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="0" sm="0" md="0" lg="0" xl="0">
            <b-modal v-model="kardexProducto" size="xl">
              <template slot="modal-header">
                <h3><b>Producto: </b>{{nombreProducto.descripcion}} | <b>Stock: </b>{{nombreProducto.stock}}</h3>
              </template>
              <b-row>
                <b-col cols="12" sm="2"	md="2"	lg="3"	xl="10">   
                  <b-form inline>
                      Desde: 
                        <datepicker  v-model="f1" 
                        :format="customFormatter" 
                        :bootstrap-styling="true"
                        :placeholder="currentdate"
                        :language="es" 
                        class="input-placedark input-dark ml-2 mr-2">
                        </datepicker> 
                      Hasta:
                        <datepicker v-model="f2" 
                        :format="customFormatter" 
                        :bootstrap-styling="true"
                        :placeholder="currentdate" 
                        :language="es"
                        class="input-placedark input-dark ml-2 mr-2">
                        </datepicker>   
                        <b-button title="Buscar" style="background-color:#7DC4CA" @click="buscarPorFecha"><i class="fa fa-search"></i></b-button>         
                  </b-form>          
                </b-col>
                <b-col>
                  <b-button variant="warning" @click="exportarKardexProducto">Exportar</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col cols="12">
                  <h4 class="colorTitulo">INGRESOS</h4>
                </b-col>
              </b-row>
              <template v-if="cargandoKardex">
                <b-row>
                  <b-col cols="6"></b-col>
                  <b-col>
                   <h1><i class="fa fa-spin fa-spinner"></i></h1>
                  </b-col>
                  <b-col></b-col>
                </b-row>
              </template>
              <template v-else>
               <b-row><!--TABLA INGRESOS-->
                 <b-col>
                  <b-table
                    head-variant="light"                 
                    bordered
                    responsive
                    small
                    hover
                    :items="ingresosItem" 
                    :fields="fields_listaItemsIngresos">
                    <template slot="documento" slot-scope="row">
                      {{row.item.serie}} - {{row.item.numero}}
                    </template>
                  </b-table>
                  <template v-if="ingresosItem.length === 0">
                   <b-row>
                    <b-col cols="5"></b-col>
                    <b-col>
                      <h4> Sin Información </h4>
                    </b-col>
                   </b-row>
                  </template>               
                  <b-row>
                      <b-col cols="9">
                        <p>Mostrando del {{desdeKardex}} al {{hastaKardex}} de un total de {{totalKardex}} registros</p>
                      </b-col>
                      <b-col>
                        <b-pagination
                          size="sm"
                          :total-rows="totalKardex"
                          v-model="currentPageKardex"
                          @input="kardexReporteIngresos"
                          :per-page="limitKardex">
                        </b-pagination>
                    </b-col>
                  </b-row>
                 </b-col>
               </b-row>
               </template>                  
               <br>
               <b-row>                
                <b-col>
                  <h4 class="colorTitulo">SALIDAS</h4>
                </b-col>
              </b-row>
              <template v-if="cargandoKardex2">
                 <b-row>
                  <b-col cols="6"></b-col>
                  <b-col>
                   <h1><i class="fa fa-spin fa-spinner"></i></h1>
                  </b-col>
                  <b-col></b-col>
                </b-row>
               </template>
               <template v-else>
               <b-row><!--TABLA SALIDAS-->
                 <b-col>
                   <b-table
                    head-variant="light"  
                    bordered
                    sresponsive
                    small
                    hover
                    :items="salidasItem" 
                    :fields="fields_listaItemsSalidas">
                    <template slot="documento" slot-scope="row">
                      {{row.item.serie}} - {{row.item.numero}}
                    </template>
                  </b-table>
                  <template v-if="salidasItem.length === 0">
                   <b-row>
                    <b-col cols="5"></b-col>
                    <b-col>
                      <h4> Sin Información </h4>
                    </b-col>
                   </b-row>
                  </template>  
                    <b-row>
                      <b-col cols="9">
                        <p>Mostrando del {{desdeKardex2}} al {{hastaKardex2}} de un total de {{totalKardex2}} registros</p>
                      </b-col>
                      <b-col>
                        <b-pagination
                          size="sm"
                          :total-rows="totalKardex2"
                          v-model="currentPageKardex2"
                          @input="kardexReporteSalidas"
                          :per-page="limitKardex2">
                        </b-pagination>
                      </b-col>
                    </b-row>
                 </b-col>
               </b-row>
               </template>
            </b-modal>
          </b-col>
          <b-col cols="12 espacio" sm="3" md="3" lg="3" xl="3">
            <b-btn v-b-modal.modal1 variant="primary" @click.prevent="buttonAddProduct()">
              <i class="fa fa-plus"></i> Agregar
            </b-btn>
          </b-col>
          <b-col cols="12" sm="9" md="9" lg="9" xl="9">
            <template>
              <b-row>
                <b-col cols="8" sm="8" md="6" lg="6" xl="6">
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Cargar archivo..."
                  ></b-form-file>
                </b-col>
                <b-col cols="4" sm="4" md="6" lg="6" xl="6">
                  <b-button v-if="importando" variant="success" @click="importProduct">
                    <i class="fa fa-upload"></i> Importar
                  </b-button>
                  <b-button v-else variant="secondary">
                    <i class="fa fa-spin fa-spinner"></i> Importando...
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
        <b-modal id="modal1" :title="title" v-model="nuevoproducto" size="xl">
          <div role="group">
            <b-row>
              <b-col v-if="ocultarCodigosItems">
                <b-form-group 
                  label-for="input_codigoProducto"
                  :invalid-feedback="invalidFeedbackCodigoProducto"
                  :valid-feedback="validFeedbackCodigoProducto"
                >
                <b-input-group>
                  <b-form-input style="border-color:skyblue"
                    placeholder="Cod. Barras" 
                    :value="codigoProducto"
                    v-model="codigoProducto" 
                    :state="codigoProducto"
                    @input="removeSpaces"
                    @keyup.enter="serchGoogle()">
                  </b-form-input>
                    <template #append>
                      <b-input-group-text>
                        <!-- <b-button class="pb-0 pt-0" size="sm" variant="primary" @click="cerrarListGoogle()">X</b-button> -->
                        <b-button class="pb-0 pt-0 ml-1" size="sm" variant="warning" title="regresar" @click="ocualtarCodigoBarra()">Regresar</b-button> 
                        <b-tooltip target="info-icon" triggers="hover">
                          "Ingrese el código de barras de un producto y presione Enter. Iniciara una búsqueda de alternativas para crear el producto."
                          Ejemplo: 7500435129688 es el código de barras de un producto, al ingresarlo mostrará alternativas para registrarlo.
                        </b-tooltip>
                            <i id="info-icon" class="fas fa-question-circle text-black" style="margin-left: 8px; cursor: pointer; font-size: 18px;"></i>
                      </b-input-group-text>
                    </template>
                </b-input-group>
              </b-form-group>
                <b-list-group v-if="resultadosGoogleTitle.length" class="resultados-scroll">
                  <b-list-group-item 
                  class="item-select d-flex align-items-start p-2" 
                  @click="seleccionarResultado(resultado, index)"
                  v-for="(resultado, index) in resultadosGoogleTitle" 
                  :key="index">
                  <img 
                    v-if="resultado.imageUrl" 
                    :src="resultado.imageUrl" 
                    alt="Imagen de resultado" 
                    class="imagen-lista mr-2"
                  />
                  <div>
                    <h5 class="mb-1">{{ resultado.title }}</h5>
                    <!-- <p class="mb-0 text-muted">{{ resultado.snippet }}</p> -->
                  </div>
                </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="12" sm="6" md="6" lg="6" xl="3" v-else>
                <b-form-group 
                  label-for="input_codigoProducto"
                  :invalid-feedback="invalidFeedbackCodigoProducto"
                  :valid-feedback="validFeedbackCodigoProducto"
                >
                  <b-input-group  size="md">
                    <b-form-input style="border-color:skyblue"
                      autofocus
                      :value="codigoProducto"
                      required
                      v-model="codigoProducto"
                      maxlength="30"
                      type="text"
                      id="input_codigoProducto"
                      :state="codigoProducto"
                      placeholder="Codigo Interno (*)"
                      @input="removeSpaces"
                    ></b-form-input>
                    <template #append>
                      <b-input-group-text>
                        <b-button 
                          class="pb-0 pt-0" 
                          size="sm" 
                          variant="primary" 
                          @click="ocultarCodigoItem()">
                          <span class="material-icons">Nuevo <i class="fab fa-google"></i></span>
                        </b-button>
                      </b-input-group-text>
                    </template>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="6" lg="6" xl="3">
                <b-form-input style="border-color:skyblue"
                  type="text"
                  v-model="codigoProductoSunat"
                  :value="codigoProductoSunat"
                  placeholder="Codigo Sunat"
                ></b-form-input>
              </b-col>
              <b-col cols="12" sm="6" md="6" lg="6" xl="3">
                <b-form-input style="border-color:skyblue"
                  type="text"
                  v-model="codigoProductoGs1"
                  :value="codigoProductoGs1"
                  placeholder="Codigo Barras"
                ></b-form-input>
              </b-col>
              <b-col cols="12" sm="6" md="6" lg="6" xl="3">
                <select style="border-color:skyblue"
                  class="custom-select mr-sm-2"
                  id="inlineFormCustomSelect"
                  v-model="unidadMedidaCantidad"
                  :value="unidadMedidaCantidad">
                  <option
                    :value="unidad.codigo"
                    v-for="unidad in unidades"
                    v-bind:key="unidad.id"
                  >{{ unidad.descripcion }}</option>
                </select>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="12" sm="5" md="5" lg="3" xl="3" style="margin-top:0.2%"> 
                  Seleccione una Categoria            
                  <select style="border-color:skyblue"
                  class="custom-select"
                  id="inlineFormCustomSelect"
                  v-model="indexCategoria"
                  :value="indexCategoria">
                      <option            
                        :value="itemcat.idCategoria"           
                        v-for=" itemcat in listaCategoria"                      
                        v-bind:key="itemcat.idCategoria">
                         {{itemcat.descripcion}}                        
                      </option>
                  </select>
              </b-col>              
              <b-col cols="12" sm="5" md="5" lg="9" xl="9" class="mt-4">
                <b-form-input style="border-color:skyblue"
                  type="text"
                  v-model="descripcion"
                  :value="descripcion"
                  placeholder="Descripcion (*)"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="5" md="5" lg="3" xl="3" class="mt-4">
                <b-form-input style="border-color:skyblue"
                  type="number"
                  v-model="precioUnitario"
                  :value="precioUnitario"
                  placeholder="Precio (*)"
                ></b-form-input>
              </b-col>
              <b-col cols="12" sm="5" md="5" lg="3" xl="2" class="mt-4">
                <select style="border-color:skyblue" class="custom-select mr-sm-2" v-model="especificacionIgv">
                  <option
                    :value="afec.id"
                    v-for="afec in listaafectacion"
                    v-bind:key="afec.id"
                  >{{ afec.descripcion }}</option>
                </select>
              </b-col>
              <b-col cols="12" sm="5" md="5" lg="3" xl="2">
                  <div class="p-1" style="border-radius:5px;border: 1px solid skyblue;width:100%;margin-top:16%">                   
                  <b-form-checkbox v-model="descuentoStock">No descuenta stock</b-form-checkbox>   
                  </div>
              </b-col>
              <b-col cols="2">
                <b-form-input class="mt-4" style="border-color:skyblue"  v-model="stockMinimo" placeholder="Stock mínimo" type="number" title="Stock mínimo"></b-form-input>
              </b-col>
              <b-col cols="12" sm="5" md="5" lg="3" xl="2" class="mt-4">
                <div>
                    <b-dropdown variant="primary" id="dropdown-left" text="Visualizar Item">
                       <b-form-checkbox
                          class="mt-2 ml-2 mb-2"
                          id="checkbox-1"
                          @click="mostrarItem()"
                          v-model="valor0"
                          :disabled="!valor0Item"
                          name="checkbox-1"
                          value:true
                          unchecked-value:false
                        >Normal
                      </b-form-checkbox>
                      <b-form-checkbox
                          class="mt-2 ml-2 mb-2"
                          id="checkbox-2"
                          @click="mostrarItem()"
                          v-model="valor1"
                          :disabled="!valor1Item"
                          name="checkbox-2"
                          value:true
                          unchecked-value:false
                        >Grifos
                      </b-form-checkbox>
                      <b-form-checkbox
                          class="mt-2 ml-2 mb-2"
                          id="checkbox-3"
                          @click="mostrarItem()"
                          v-model="valor2"
                          :disabled="!valor2Item"
                          name="checkbox-3"
                          value:true
                          unchecked-value:false
                        >Casa Cambio
                      </b-form-checkbox>
                    </b-dropdown>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="5" md="5" lg="4" xl="3" class="mt-4"> 
                 <b-form-select style="border-color:skyblue" class="mb-3" v-model="selectedISC" :options="optionsISC"></b-form-select>
              </b-col>
              <!-- ISC -->
              <b-col cols="12" sm="5" md="5" lg="3" xl="2" class="mt-4" v-if="selectedISC == 1">
                <b-input-group>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                      <b-form-input style="border-color:skyblue" v-model="valorISC" type="number" autofocus ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="12" sm="5" md="5" lg="3" xl="2" class="mt-4" v-if="selectedISC == 2">
                <b-input-group >
                    <template #append>
                      <b-input-group-text>S/</b-input-group-text>
                    </template>
                      <b-form-input style="border-color:skyblue" v-model="valorISC" type="number"  autofocus ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="12" sm="5" md="5" lg="4" xl="4" class="mt-4" v-if="selectedISC == 3">
                  <div style="width:49%;float:left">
                     <b-input-group >
                        <template #append>
                          <b-input-group-text>S/</b-input-group-text>
                        </template>
                          <b-form-input style="border-color:skyblue" v-model="valorReferencial" type="number" autofocus ></b-form-input>
                      </b-input-group>
                  </div>
                  <div style="width:49%;float:right">
                      <b-input-group >
                        <template #append>
                          <b-input-group-text>%</b-input-group-text>
                        </template>
                        <b-form-input style="border-color:skyblue" v-model="valorISC" @keyup.enter="valorUnitIsc()" type="number"></b-form-input>
                      </b-input-group>
                  </div> 
              </b-col>            
              <!-- FIN ISC -->
              <b-col cols="12" sm="5" md="5" lg="3" xl="2">
                <b-input-group class="mt-4">
                <template #append>
                  <b-input-group-text>%</b-input-group-text>
                </template>
                <b-form-input style="border-color:skyblue"  v-model="otrosCargos" placeholder="Otros Cargos" type="number" title="Otros Cargos"></b-form-input>
                </b-input-group>
              </b-col>
              <!-- <b-col cols="12" sm="5" md="5" lg="2" xl="2" class="mb-4">
                <b-form-input style="border-color:skyblue" disabled class="mt-4" v-model="totalCargosProducto"></b-form-input>
              </b-col> -->
            </b-row>
            <b-row class="">
                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text>
                        <b-button @click="limpiarFecha()" size="sm" variant="warning" class="pr-1 pb-0 pl-1 pt-0"><i class="fa fa-trash"></i></b-button>
                      </b-input-group-text>
                    </template>
                  <datepicker
                    v-model="fechaVencimientoProducto"
                    :format="customFormatterFVProducto"
                    :language="es"
                    :bootstrap-styling="true"
                    placeholder="Fecha Vencimiento">
                  </datepicker>
                  </b-input-group>
                </b-col>
                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                  <b-input v-model="loteProducto"  maxlength="50" placeholder="Lote"></b-input>
                </b-col>
                <!-- <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                  <b-input v-model="pesoProducto"  type="number" placeholder="Peso KG"></b-input>
                </b-col> -->
              </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-btn v-if="update" block v-b-toggle.complementos size="sm" variant="primary" class="mb-2">Agregar Complementos</b-btn>
                <b-collapse id="complementos">
                  <b-row>
                    <b-col cols="2">
                      <b-form-input v-model="codigoComplemento" placeholder="Código"></b-form-input>
                    </b-col>
                    <b-col cols="8">
                      <b-form-input v-model="descripcionComplemento" @keyup.enter="crearComplemento()" placeholder="Descripción"></b-form-input>
                    </b-col>
                    <b-col v-if="!edicionComplemento" cols="2">
                      <b-button variant="primary" @click="crearComplemento()">Crear</b-button>
                    </b-col>
                    <b-col v-else cols="2">
                      <b-button variant="warning" @click="guardarEdicionComplemento()">Editar</b-button>
                    </b-col>
                  </b-row>
                  <br>
                  <template v-if="cargandoComplementos">
                    <b-row class="mb-2">
                      <b-col class="text-center" cols="12">
                        <h3>Cargando Complementos <i class="fa fa-spin fa-spinner"></i></h3> 
                      </b-col>
                    </b-row>
                  </template>
                  <template v-else>
                    <b-row>
                      <b-col>
                        <b-table
                          bordered
                          responsive
                          small
                          hover
                          :items="complementosItem"
                          :fields="fields_complementosItem"
                        >
                          <template slot="acciones" slot-scope="row">
                            <b-button-group>
                            <b-button
                              variant="danger"
                              size="sm"
                              class="btn-group"
                              @click.prevent="eliminarComplemento(row.item, row.index)"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                              variant="warning"
                              size="sm"
                              class="btn-group"
                              @click.prevent="editarComplemento(row.item, row.index)"
                            >
                              <i class="fa fa-edit"></i>
                            </b-button>
                          </b-button-group>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </template>
                </b-collapse>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-file 
                  v-model="encodeimage"
                  :state="Boolean(encodeimage)"
                  placeholder="seleccione una imagen..."
                  drop-placeholder="Arrastre imagen aquí..."
                  @input="img64"
                ></b-form-file>
                <div v-if="image" class="mt-4 text-center">
                    <img class="rounded img-thumbnail mr-4" width="60%" :src="image" > 
                <b-button variant="danger" @click="removeImage">Eliminar Imagen</b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <div slot="modal-footer" class="w-100">
            <template v-if="validProduct()">
              <template v-if="add">
                <b-btn
                  v-if="!sendproducto"
                  class="float-right"
                  variant="primary"
                  @click="sendProduct"
                >Guardar</b-btn>
                <b-btn v-else class="float-right" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Guardando ...
                </b-btn>
              </template>
              <template v-else-if="update">
                <b-btn
                  v-if="!sendproducto"
                  class="float-right"
                  variant="primary"
                  @click="updateProduct"
                >Guardar</b-btn>
                <b-btn v-else class="float-right" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Guardando ...
                </b-btn>
              </template>
            </template>
            <template v-else>
              <div class="text-right">
                <button class="btn btn-secondary" disabled>
                  <i class="fa fa-send"></i> Guardar
                </button>
              </div>
            </template>
          </div>
        </b-modal>
      </div>
    </template>
    <vue-snotify></vue-snotify>
  </b-card>
</template>

<script>
import axios from "axios";
import { UnidadMedida } from "@/shared/utils";
import { TipoAfectacion } from "@/shared/utils";
import { BFormFile } from "bootstrap-vue";
import { log } from "util";
import { listaDetraciones } from "@/shared/utils";
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import download from 'downloadjs'
export default {
  name: "ProductoCrud",
  components: {
    BFormFile,
    Datepicker
  },
  data: () => {
    return {
       listaCategoria:[],
       indexCategoria:421,
       descripcionCat:'',
       listaCategoriaBuscar:[],
       sinresultados:false,
       cargandoDescription:false,
       listades:true,
       nodescription:false,
       idCategoria:'',
       nocategoria:'no ingreso categoria',

      checkdetraccion: false,
      codigoDetraccion: "001",
      listaDetraccion: listaDetraciones,
      small: true,
      validCodigoProducto: false,
      updateItem: {},
      especificacionIgv: "01",
      listaafectacion: TipoAfectacion,
      title: "Añadir Producto",
      pactual: 1,
      limiteItem:15,
      limite: 15,
      orden: "desc",
      importando: true,
      fileName: "",
      attachment: "",
      emitiendo: false,
      file: null,
      idProductUpdate: "",
      add: false,
      update: false,
      unidades: UnidadMedida,
      sendproducto: false,
      nuevoproducto: false,
      total: 0.0,
      desde: 0.0,
      hasta: 0.0,
      cargando: false,
      codigoProducto: "",
      codigoProductoSunat: "",
      codigoProductoGs1: "",
      unidadMedidaCantidad: "NIU",
      descripcion: "",
      precioUnitario: "",
      stockMinimo:"",
      listaProducts: [],
      productos: [],
      productos_fields: [
        { key: "codigo", label: "Codigo Interno", sorteable: true },
        { key: "codigoProductoSunat", label: "Codigo Sunat", sorteable: true },
        { key: "codigoProductoGs1", label: "Codigo Barras", sorteable: true },
        { key: "categoria", label: " Categoria Prod.", sorteable: true },
        { key: "unidadMedida", label: "Unidad Medida", sorteable: true },
        { key: "descripcion", label: "Descripcion", sorteable: true },
        { key: "tipoAfectacionIgv", label: "Afectación", sorteable: true },
        { key: "stock", label: "Stock", sorteable: true },
        { key: "stockMinimo", label: "Stock Minimo", sorteable: true },
        { key: "precioUnitario", label: "Precio", sorteable: true },
        { key: "precioCosto", label: "Costo", sorteable: true },
        { key: "estadooc", label: "Estado OC", sorteable: true },
        { key: "acciones", label: "Acciones" }
      ],
      product: "",
      lista: null,
      buscar: "",
      rejectedProducts: null,
      parambus: "code",
      cadenabusqueda: "",
      cargandoproducto: false,
      encodeimage: null,
      image: null,
      image64: "",
      selectedISC: 0,
      optionsISC: [
          { value: 0, text: 'Opciones ISC' },
          { value: 1, text: 'Valor Venta %' },
          { value: 2, text: 'Monto Específico' },
          { value: 3, text: 'Precio Sugerido' },
      ],
      descuentoStock: false,
      valorISC:'',
      valorReferencial:'',
      selectedMostrarItem: 0,
      optionsMostrarItem: [
          { value: 0, text: 'Mostrar en todos'},
          { value: 1, text: 'Grifo' },
          { value: 2, text: 'Casa Cambio' },
      ],
      valor0:true,
      valor1:false,
      valor2:false,
      valor0Item:true,
      valor1Item:false,
      valor2Item:false,
      otrosCargos:'',
      totalCargosProducto:'',
      kardexProducto:false,
      ingresosItem:[],
      fields_listaItemsIngresos:[
        {key:'descripcionMovimiento',label:'Movimiento'},
        {key:'documento',label:'Documento'},
        {key:'cantidad',label:'Cantidad'},
        {key:'precioVentaUnitario',label:'Precio Unit.'},
        {key:'precioVentatotal',label:'Precio Total'},
        // {key:'stock',label:'Stock'},
        {key:'fechaMovimiento',label:'Fecha Movimiento'}
      ],
      salidasItem:[],
      fields_listaItemsSalidas:[
        {key:'descripcionMovimiento',label:'Movimiento'},
        {key:'documento',label:'Documento'},
        {key:'cantidad',label:'Cantidad'},
        {key:'precioVentaUnitario',label:'Precio Unit.'},
        {key:'precioVentatotal',label:'Precio Total'},
        // {key:'stock',label:'Stock'},
        {key:'fechaMovimiento',label:'Fecha Movimiento'}
      ],
      orderKardex:'desc',
      limitKardex:15,
      currentPageKardex:1,
      totalKardex: 0.0,
      desdeKardex: 0.0,
      hastaKardex: 0.0,
      orderKardex2:'desc',
      limitKardex2:15,
      currentPageKardex2:1,
      totalKardex2: 0.0,
      desdeKardex2: 0.0,
      hastaKardex2: 0.0,
      es: es,
      f1:'',
      f2:'',
      currentdate:'',
      codigoItemKardex:'',
      nombreProducto:'',
      cargandoKardex:false,
      cargandoKardex2:false,
      resultado:null,
      busquedaGoogle:'',
      resultadosGoogleTitle: [],
      resultadosGoogleImg:[],
      ocultarCodigosItems:false,
      complementosItem: [],
      fields_complementosItem: [
        { key: "codigo", label: "Código" },
        { key: "descripcion", label: "Descripción" },
        { key: "acciones", label: "Acciones" }
      ],
      codigoComplemento: '',
      descripcionComplemento: '',
      cargandoComplementos:false,
      edicionComplemento: false,
      idComplemento: '',
      fechaVencimientoProducto:null,
      loteProducto:'',
      // pesoProducto:0.00,
    };
  },
  mounted() {
    this.listProduct();
    this.getCategoria();
    this.iniciarFechaKardex();
  },
  computed: {
    stateCodigoProducto() {
      // let expreg = new RegExp("^[a-zA-Z0-9_]{2,30}$");
      let expreg = new RegExp("^[a-zA-Z0-9_\\-\\/\\.ñÑ]{2,30}$")
      // let expreg = new RegExp("^\b[\w.%+-]+@[\w.-]+\.[a-zA-Z0-9][^\"]{3,30}$")
      if (this.codigoProducto.length == 0) {
        return false;
      } else if (!expreg.test(this.codigoProducto)) {
        return false;
      } else if (this.codigoProducto.length >1) { 
        return true;
      }
    },
    invalidFeedbackCodigoProducto() {
      // let expreg = new RegExp("^[a-zA-Z0-9]{3,30}$")
      if (this.codigoProducto.length == 0) {
        return "Ingresa un codigo de Producto";
      } else if (this.codigoProducto.length <= 1) {
        return "Minimo 2 caracteres";
      } else if (this.codigoProducto.length > 3) {
        return "La cadena contiene errores";
      }
    },
    validFeedbackCodigoProducto() {
      this.validCodigoProducto = this.stateCodigoProducto;
      return this.stateCodigoProducto === true ? "Perfecto" : "";
    }
  },
  watch:{
    valor0(){
      if(this.valor0){
        this.selectedMostrarItem = 0
        this.valor1Item = false
        this.valor2Item = false
      }else if(!this.valor0){
        this.valor1Item = true
        this.valor2Item = true 
      }
    },
    valor1(){
      if(this.valor1){
        this.selectedMostrarItem = 1
        this.valor0Item = false
        this.valor2Item = false
      }else if(!this.valor1){ 
        this.valor0Item = true
        this.valor2Item = true 
      }
    },
    valor2(){
      if(this.valor2){
        this.selectedMostrarItem = 2
        this.valor0Item = false
        this.valor1Item = false
      }else if(!this.valor2){
        this.valor0Item = true
        this.valor1Item = true 
      }
    },
    otrosCargos(){
      if(this.otrosCargos > 0){
        let cargosProducto = this.otrosCargos/100
        let totalSumaCargos = cargosProducto + (this.$store.state.igv == 18 ? 1.18 : 1.105)
        let total = this.precioUnitario / totalSumaCargos
        this.totalCargosProducto =  total
      }else if(this.otrosCargos == ""){
        this.totalCargosProducto = 0
      }
    }
  },
  methods: {
    removeSpaces() {
        this.codigoProducto = this.codigoProducto.replace(/\s/g, '');
    },
    getCategoria(){
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/listar',{
                 token: this.$store.getters.userToken,
                 order:this.order,
                 limit:this.limite
            })
            .then(response =>(
                this.listaCategoria = response.data,
                // this.listaCategoria.push({idCategoria:0,descripcion:'Otros'}), 
                this.cargando = false
            ))
            .catch(error => {
                this.cargando = true;
            })
        },

        getReceiversDescription: function () {
            this.listaCategoriaBuscar = []
            if(this.descripcionCat.length > 1 && !this.sinresultados){
            this.sinresultados = true,
            setTimeout(() => 
            this.cargandoDescription = true,
            this.listades = true,
            this.nodescription = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                buscar: this.descripcionCat
            })
            .then(response => (
                this.listaCategoriaBuscar = response.data.response,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.receivercountDescription(this.listaCategoriaBuscar.length)
            ))
            .catch(error => (
                this.cargandoDescription = false,
                this.sinresultados = true,
                this.menssageErrorDescripcion(error.response.data)
            )) 
            , 200);
            }
        },
        receivercountDescription: function (value) {
                if(!value)
                {
                this.nodescription = true
                }
                else
                {
                this.nodescription = false
                }
        },
    img64: function(file) {
      if (!file) {
        console.error("No se seleccionó ningún archivo.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result;
        this.image = base64String; // Imagen completa con el prefijo
        this.image64 = base64String.replace(/^data:(.*?);base64,/, ''); // Solo el contenido Base64
      };
      reader.readAsDataURL(file); // Convierte el archivo a base64
    },

    removeImage: function() {
      this.image = "";
      this.image64 = "";
      this.encodeimage = ""
    },
    changeEstado: function(data) {
      this.$swal({
        title: "Cambiar de estado OC",
        text:
          "Al cambiar el estado del item podra ser visto por sus clientes al emitir una OC",
        icon: "error",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.ocestadoChange(data);
        } else {
          data.ordenCompra = false;
        }
      });
    },
    ocestadoChange: function(data) {
      let estado = "";
      data.ordenCompra == true ? (estado = 1) : (estado = 0);
      axios
        .post(process.env.VUE_APP_API_URL + "productos/oc/estado", {
          token: this.$store.getters.userToken,
          idproducto: data.idProducto,
          ocestado: estado
        })
        .then(response => {})
        .catch(
          error => (
            this.$snotify.error(error.response.data.msg, "Error"),
            (data.ordenCompra = false)
          )
        );
    },
    validProduct: function() {
      if (
        this.validCodigoProducto &&
        this.unidadMedida != "" &&
        this.precioUnitario != "" &&
        this.descripcion != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    buttonAddProduct: function() {
      this.update = false;
      (this.title = "Añadir Producto"), (this.add = true), this.cleanProduct();
    },
    cleanProduct: function() {
      (this.codigoProducto = ""),
        (this.codigoProductoSunat = ""),
        (this.codigoProductoGs1 = ""),
        (this.descripcion = ""),
        (this.precioUnitario = ""),
        (this.unidadMedidaCantidad = "NIU"),
        (this.indexCategoria = ''),
        (this.selectedISC = 0),
        (this.valorISC = ''),
        (this.valorReferencial = ''),
        (this.tipoValorISC = ''),
        (this.otrosCargos = '' ),
        (this.stockMinimo = '')
        this.image = '',
        this.fechaVencimientoProducto=null,
        this.loteProducto = ''
        // this.pesoProducto =0.00


    },
    sendProduct: function() {
      let producto = {
        isc:{
          tipoISC:'',
          valorReferencial:'',
          valorISC:'',
          tipoValorISC:''
        },
        adicionales:{
          mostrarItemEn:''
        }

      };

      this.sendproducto = true;
      this.nuevoproducto = true;
      producto.codigo = this.codigoProducto;
      producto.unidadMedida = this.unidadMedidaCantidad;
      producto.descripcion = this.descripcion;
      producto.precioUnitario = this.precioUnitario;
      producto.tipoAfectacionIgv = this.especificacionIgv;
      producto.idCategoria = this.indexCategoria;
      producto.otrosCargos = this.otrosCargos;
      producto.stockMinimo = this.stockMinimo;
      if(this.fechaVencimientoProducto !==null){
        producto.fechaVencimiento = this.$moment(this.fechaVencimientoProducto).format('YYYY-MM-DD')
      }else{
        producto.fechaVencimiento = null
      }
      producto.lote = this.loteProducto;
      // producto.peso = this.pesoProducto;
      if(this.descuentoStock == true){
        producto.descuentaStock = '2'
      }else{
        producto.descuentaStock = '1'
      }
      if(this.selectedISC != 0){
        producto.isc.tipoISC = this.selectedISC;
        producto.isc.valorReferencial = this.valorReferencial ;
        producto.isc.valorISC = this.valorISC;
      }else{
        delete producto.isc;
      }
      if(this.selectedISC == 2){
        producto.isc.tipoValorISC = "fijo"
      }else if(this.selectedISC == 1 || this.selectedISC == 3){
        producto.isc.tipoValorISC = "porcentaje"
      }
    
      if (this.codigoProductoSunat != "") {
        producto.codigoProductoSunat = this.codigoProductoSunat;
      }
      if (this.codigoProductoGs1 != "") {
        producto.codigoProductoGs1 = this.codigoProductoGs1;
      }
      producto.mostrarItemEn = this.selectedMostrarItem;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/grabar", {
          token: this.$store.getters.userToken,
          producto,
          encodeimage: this.image64
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.product = response.data),
            (this.sendproducto = false),
            (this.nuevoproducto = false),
            this.cleanProduct(),
            this.removeImage(),
            (this.add = false),
            this.listProduct()
          )
        )
        .catch(
          error => (
            (this.sendproducto = false),
            (this.nuevoproducto = false),
            (this.add = false),
            this.$snotify.error(error.response.data.msg, "Error")
          )
        );
    },
    deleteProduct: function(value, descripcion) {
      this.$swal({
        title: "",
        text: "¿Seguro de eliminar " + descripcion + " de la lista?",
        icon: "error",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.cargando = true;
          axios
            .post(process.env.VUE_APP_API_URL + "productos/eliminar", {
              token: this.$store.getters.userToken,
              id: value
            })
            .then(
              response => (
                (this.cargando = false),
                this.$snotify.success(response.data.msg, "Éxito"),
                this.listProduct()
              )
            )
            .catch(error => {
              this.cargando = false;
            });
        } else {
        }
      });
    },
    listProduct: function() {
      this.cargando = true;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/listar", {
          token: this.$store.getters.userToken,
          page: this.pactual,
          limit: this.limite,
          order: this.orden
        })
        .then(
          response => (
            (this.productos = response.data.producto.data),
            (this.total = response.data.producto.total),
            (this.desde = response.data.producto.from),
            (this.hasta = response.data.producto.to),
            (this.cargando = false),
            this.productos.forEach(function(element) {
              if (element.ordenCompra === 1) {
                element.ordenCompra = true;
              } else if (element.ordenCompra === 0) {
                element.ordenCompra = false;
              }
            })
          )
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.response.message, "Error");
          this.cargando = false;
        });
    },
    searchProduct: function() {
      this.cargandoproducto = true;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/buscar", {
          token: this.$store.getters.userToken,
          filtro: this.parambus,
          p: this.cadenabusqueda
          // 'name, code, codesunat, codegs1'
          // Parametro ej: Shoes -> sho
        })
        .then(
          response => (
            (this.productos = response.data.response),
            (this.cargandoproducto = false),
            (this.cadenabusqueda = "")
          )
        )
        .catch(
          error => (
            (this.cargandoproducto = false),
            this.$snotify.error(error.response.data.response.message, "Error")
          )
        );
    },
    setUpdateProduct: function(value) {
      var uno = {};
      uno = value.category;
      (this.title = "Actualizar Producto"),
        (this.update = true),
        (this.updateItem.codigoProducto = value.codigo),
        (this.updateItem.unidadMedidaCantidad = value.unidadMedida),
        (this.updateItem.descripcion = value.descripcion),
        (this.updateItem.precioUnitario = value.precioUnitario),
        (this.updateItem.especificacionIgv = "01"),
        (this.updateItem.codigoProductoSunat = value.codigoProductoSunat),
        (this.updateItem.codigoProductoGs1 = value.codigoProductoGs1),
        (this.updateItem.idProductUpdate = value.idProducto),
        this.updateItem.fechaVencimientoProducto = value.fechaVencimiento,
        this.updateItem.loteProducto = value.lote
        // this.updateItem.pesoProducto = value.peso
        if(uno!=null){
          (this.updateItem.indexCategoria = uno.idCategoria);
        }else{
          (this.updateItem.indexCategoria = 'Otros');
        }
        if(value.descuentaStock == '1'){
          this.descuentoStock = false;
        }else if(value.descuentaStock == '2' ){
          this.descuentoStock = true;
        }
        if(value.isc != null ){
          if(value.isc.tipoISC == 1){
            this.selectedISC = 1;
            this.valorISC = value.isc.valorISC;
          }else if(value.isc.tipoISC == 2){
            this.selectedISC = 2;
            this.valorISC = value.isc.valorISC;
          }else if(value.isc.tipoISC == 3){
            this.selectedISC = 3;
            this.valorISC = value.isc.valorISC;
            this.valorReferencial = value.isc.valorReferencial
          }
        }else{
           this.selectedISC = 0;
        }
        if(value.mostrarItemEn == null){
          this.selectedMostrarItem = 0;
        }else{
          this.selectedMostrarItem = value.mostrarItemEn;
          if(value.mostrarItemEn == 0){
            this.valor2 = false
            this.valor1 = false
            this.valor0 = true
          }else if(value.mostrarItemEn == 1){
            this.valor2 = false
            this.valor1 = true
            this.valor0 = false
          }else if(value.mostrarItemEn == 2){
            this.valor2 = true
            this.valor1 = false
            this.valor0 = false
          }
        }
        this.stockMinimo = value.stockMinimo,
        this.otrosCargos = value.otrosCargos,
        (this.codigoProducto = value.codigo),
        (this.unidadMedidaCantidad = value.unidadMedida),
        (this.descripcion = value.descripcion),
        (this.precioUnitario = Number.parseFloat(value.precioUnitario).toFixed(2))
        this.fechaVencimientoProducto = value.fechaVencimiento,
        this.loteProducto = value.lote
        // this.pesoProducto = value.peso
        if(value.tipoAfectacionIgv == "01"){
          (this.especificacionIgv = "01")
        }else if(value.tipoAfectacionIgv == "02"){
           (this.especificacionIgv = "02")
        }else if(value.tipoAfectacionIgv == "03"){
          (this.especificacionIgv = "03")
        }
        (this.codigoProductoSunat = value.codigoProductoSunat),
        (this.codigoProductoGs1 = value.codigoProductoGs1),
        (this.idProductUpdate = value.idProducto)
        this.image = value.uriImagen   
        if(uno!=null){
          (this.indexCategoria = uno.idCategoria);
        }else{
          (this.indexCategoria = '');
        }
        this.listarComplementos();
    },
    updateProduct: function() {
      let producto = {
        isc:{
          tipoISC:'',
          valorReferencial:'',
          valorISC:'',
          tipoValorISC:''
        }
      };
      this.nuevoproducto = true;
      this.sendproducto = true;
      if (this.codigoProducto != this.updateItem.codigoProducto) {
        producto.updatecode = this.codigoProducto;
      }
      producto.updatemedida = this.unidadMedidaCantidad;
      producto.updatename = this.descripcion;
      producto.updateprecio = this.precioUnitario;
      producto.tipoAfectacionIgv = this.especificacionIgv;
      producto.id = this.idProductUpdate;
      producto.updatesunat = this.codigoProductoSunat;
      producto.idCategoria = this.indexCategoria;
      producto.updategs1 = this.codigoProductoGs1;
      producto.otrosCargos = this.otrosCargos;
      producto.stockMinimo = this.stockMinimo;
      if(this.fechaVencimientoProducto !==null){
        producto.fechaVencimiento = this.$moment(this.fechaVencimientoProducto).format('YYYY-MM-DD')
      }else{
        producto.fechaVencimiento = null
      }
      producto.lote = this.loteProducto
      // producto.peso = this.pesoProducto
      if(this.selectedISC != 0){
        producto.isc.tipoISC = this.selectedISC;
        producto.isc.valorReferencial = this.valorReferencial ;
        producto.isc.valorISC = this.valorISC;
      }else{
        delete producto.isc;
      }
      if(this.selectedISC == 2){
        producto.isc.tipoValorISC = "fijo"
      }else if(this.selectedISC == 1 || this.selectedISC == 3){
        producto.isc.tipoValorISC = "porcentaje"
      }
      /*if (this.codigoProductoGs1 != this.updateItem.codigoProductoGs1) {
        producto.updategs1 = this.codigoProductoGs1;
      }*/
      if(this.descuentoStock == true){
        producto.descuentaStock = '2'
      }else{
        producto.descuentaStock = '1'
      }
      producto.mostrarItemEn = this.selectedMostrarItem;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/actualizar", {
          token: this.$store.getters.userToken,
          producto,
          encodeimage: this.image64
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Éxito"),
            (this.sendproducto = false),
            (this.update = false),
            (this.idProductUpdate = ""),
            (this.nuevoproducto = false),
            this.cleanProduct(),
            this.removeImage(),
            this.listProduct()
          )
        )
        .catch(
          error => (
            this.workErrorProduct(error),
            (this.sendproducto = false),
            (this.idProductUpdate = ""),
            (this.update = false),
            (this.nuevoproducto = false)
          )
        );
    },
    workErrorProduct: function(error) {
      if (error.response.data.success == 0) {
        this.$snotify.error(error.response.data.msg, "Error");
      }
    },
    importProduct: function() {
      this.importando = false;
      this.formData = new FormData();
      this.formData.append("token", this.$store.getters.userToken);
      this.formData.append("productos", this.file);
      axios
        .post(
          process.env.VUE_APP_API_URL + "productos/importar",
          this.formData,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          this.evalueResponseProduct(response);
        })
        .catch(error => {
          this.evalueResponseProduct(error);
        });
    },
    evalueResponseProduct: function(val) {
      const download = require("js-file-download");
      if (val.data.type == "application/json") {
        (this.importando = true),
          this.listProduct(),
          this.$snotify.success("Productos importados exitosamente!", "Exito");
      } else {
        this.$swal({
          title: "Productos Observados",
          text:
            "Algunos productos tienen errores, a continuacion se descargara un excel con los productos a corregir...",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            download(val.data, "Productos_Observados.xls"),
              (this.importando = true),
              this.listProduct();
          } else {
          }
        });
      }
    },
    mostrarItem(){
      if(this.valor0){
        this.valor1 = false;
        this.valor2 = false
      }else if(!this.valor0){
        this.valor0 = true
        this.valor1 = true;
        this.valor2 = true
        
      }
    },
    //VISTA FORMATO FECHA
    customFormatter: function(date) {
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    iniciarFechaKardex(){
      this.currentdate = this.$moment().format("YYYY-MM-DD  HH:mm:ss"); //MUESTRA FECHA ACTUAL
      const fechaInicio = new Date();
      this.f1 = this.$moment(new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1)).format("YYYY-MM-DD HH:mm:ss");
      const fechaFin = new Date();
      this.f2 = this.$moment(new Date(fechaFin.getFullYear(), fechaFin.getMonth() + 1, 0)).format("YYYY-MM-DD 23:59:59");
    },
    //ABRE MODAL
    infoProducto(item){
      this.kardexProducto = true;
      this.nombreProducto = item;
      this.codigoItemKardex = item.codigo; //OBTIENE COD. ITEM
      this.kardexReporteIngresos();
      this.kardexReporteSalidas();
    },
    //BUSCAR KARDEX X FECHA
    buscarPorFecha(){
      this.kardexReporteIngresos();
      this.kardexReporteSalidas();
    },
    //KARDEX DEL ITEM
    kardexReporteIngresos(){
      let sendFilter=[
        {
            type:40,
            name:"TIPOMOVIMIENTO",
            value:2 //INGRESOS KARDEX
        },
        {
            type:42,
            name:"CODIGO",
            value:this.codigoItemKardex//BUSQUEDA POR CODIGO 
        },
      ]
      this.cargandoKardex = true;
      axios
      .post(process.env.VUE_APP_API_URL + "kardex/reporte",{
          token: this.$store.getters.userToken,
          q:  sendFilter,
          f1: this.f1,
          f2: this.f2,
          order:  this.orderKardex,
          limit:  this.limitKardex,
          page:   this.currentPageKardex,
      })
      .then(response=>(
          this.ingresosItem = response.data.report.data,
          this.totalKardex = response.data.report.total,
          this.desdeKardex = response.data.report.from,
          this.hastaKardex = response.data.report.to,
          this.cargandoKardex = false
      ))
      .catch(response=>(
          this.$snotify.error(error.response.data.response.message, "Error")
      ))  
    },
    kardexReporteSalidas(){
      let sendFilter=[
        {
            type:40,
            name:"TIPOMOVIMIENTO",
            value:1 //SALIDAS KARDEX
        },
        {
            type:42,
            name:"CODIGO",
            value:this.codigoItemKardex //BUSQUEDA POR CODIGO 
        },
      ]
      this.cargandoKardex2 = true;
      axios
      .post(process.env.VUE_APP_API_URL + "kardex/reporte",{
          token: this.$store.getters.userToken,
          q:  sendFilter,
          f1: this.f1,
          f2: this.f2,
          order:  this.orderKardex2,
          limit:  this.limitKardex2,
          page:   this.currentPageKardex2,
      })
      .then(response=>(
          this.salidasItem = response.data.report.data,
          this.totalKardex2 = response.data.report.total,
          this.desdeKardex2 = response.data.report.from,
          this.hastaKardex2 = response.data.report.to,
          this.cargandoKardex2 = false
      ))
      .catch(response=>(
          this.$snotify.error(error.response.data.response.message, "Error")
      ))  
    },
    exportarKardexProducto(){
      let file = '';
      let tag = document.createElement('i');
      tag.classList.add('fa','fa-spin', 'fa-spinner');
      let name = 'Kardex' + ' ' + this.f1 + '-' + this.f2 + '.xlsx';
      this.$swal({
          title: 'Procesando Reporte',
          content: tag,
          icon: 'info',
          buttons: false,
          dangerMode: false
      });
      let sendFilter=[
        // {
        //     type:40,
        //     name:"TIPOMOVIMIENTO",
        //     value:1 //SALIDAS KARDEX
        // },
        {
            type:42,
            name:"CODIGO",
            value:this.codigoItemKardex //BUSQUEDA POR CODIGO 
        },
      ]
      axios
      .post(process.env.VUE_APP_API_URL + "kardex/excel/rangofechas",{
        token: this.$store.getters.userToken,
        q:  sendFilter,
        f1: this.f1,
        f2: this.f2,
      })
      .then(response=>{
        file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
        download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        this.$swal.close()
      })
      .catch(error=>{
        console.log(error)
      })
    },
    exportarStock(){
      let file = '';
      let tag = document.createElement('i');
      tag.classList.add('fa','fa-spin', 'fa-spinner');
      let name = 'Stock.xlsx';
      this.$swal({
          title: 'Procesando Reporte',
          content: tag,
          icon: 'info',
          buttons: false,
          dangerMode: false
      });
      axios
      .post(process.env.VUE_APP_API_URL + "productos/exportar/stock",{
          token:this.$store.getters.userToken
      })
      .then(response=>{
          file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
          download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          this.$swal.close()
      })
      .catch(error=>{
        console.log(error)
      })
    },

    async serchGoogle() {


      axios.get('https://www.googleapis.com/customsearch/v1', {
        params: {
          key: 'AIzaSyBfeq9WptfmOmCX3FvWsiPQdZIlNsX_pco',
          cx: '3757748817430434e',
          q: this.codigoProducto
        }
      })
      .then(response => {
        this.resultadosGoogleTitle = response.data.items.map(item => ({
          title: item.title || '',
          snippet: item.snippet || '',
          imageUrl: (item.pagemap && item.pagemap.cse_image && item.pagemap.cse_image[0] && item.pagemap.cse_image[0].src) || ''
        }))
      })
      .catch(error => {
        console.error('Error al realizar la búsqueda:', error);
      });
    },
    cerrarListGoogle(){
      this.resultadosGoogleTitle = []
    },
    seleccionarResultado(resultado) {
      this.descripcion = resultado.title;
      this.image = resultado.imageUrl || null;

      if (this.image) {
        // Convertir la imagen a base64
        this.convertImageToBase64(this.image).then(base64Image => {
          this.image64 = base64Image; // Guardar la imagen base64 en la variable
        }).catch(error => {
          console.error("Error al convertir la imagen a base64:", error);
        });
      }
      this.resultadosGoogleTitle = []; 
    },
    convertImageToBase64(imageUrl) {
      return new Promise((resolve, reject) => {
        fetch(imageUrl)
          .then(response => response.blob())  // Obtener el archivo en formato Blob
          .then(blob => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64data = reader.result.split(',')[1]; // Extraer solo la parte base64
              resolve(base64data);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);  // Leer el blob como una URL de datos (base64)
          })
          .catch(reject);
      });
    },
    ocultarCodigoItem(){
      this.ocultarCodigosItems = true;
    },
    ocualtarCodigoBarra(){
      this.ocultarCodigosItems = false;
    },
    crearComplemento(){
      axios.
      post(process.env.VUE_APP_API_URL + "productos/complementos/insertar",{
        token: this.$store.getters.userToken,
        idProducto: this.idProductUpdate,
        codigo: this.codigoComplemento,
        descripcion: this.descripcionComplemento
      })
      .then(response => {
        this.$snotify.success(response.data.msg, "Éxito");
        this.codigoComplemento = '';
        this.descripcionComplemento = '';
        this.listarComplementos();
      })
      .catch(error => {
        this.$snotify.error(error.response.data.msg, "Error");
      });
    },
    listarComplementos(){
      this.cargandoComplementos = true;
      axios.
      post(process.env.VUE_APP_API_URL + "productos/complementos/listar",{
        token: this.$store.getters.userToken,
        idProducto: this.idProductUpdate
      })
      .then(response => {
        this.complementosItem = response.data.complementos;
        this.cargandoComplementos = false;
      })
      .catch(error => {
        this.$snotify.error(error.response.data.msg, "Error");
      });
    },
    eliminarComplemento(id){
      axios.
      post(process.env.VUE_APP_API_URL + "productos/complementos/eliminar",{
        token: this.$store.getters.userToken,
        idProductoComplemento: id.idProductoComplemento
      })
      .then(response => {
        this.$snotify.success(response.data.msg, "Éxito");
        this.listarComplementos();
      })
      .catch(error => {
        this.$snotify.error(error.response.data.msg, "Error");
      });
    },
    editarComplemento(id){
      this.idComplemento = id.idProductoComplemento;
      this.edicionComplemento = true;
      this.codigoComplemento = id.codigo;
      this.descripcionComplemento = id.descripcion;
    },
    guardarEdicionComplemento(){
      axios.
      post(process.env.VUE_APP_API_URL + "productos/complementos/actualizar",{
        token: this.$store.getters.userToken,
        idProductoComplemento: this.idComplemento,
        codigo: this.codigoComplemento,
        descripcion: this.descripcionComplemento
      })
      .then(response => {
        this.$snotify.success(response.data.msg, "Éxito");
        this.codigoComplemento = '';
        this.descripcionComplemento = '';
        this.edicionComplemento = false;
        this.listarComplementos();
      })
      .catch(error => {
        this.$snotify.error(error.response.data.msg, "Error");
      });
    },
    customFormatterFVProducto(date) {
      if(this.update){
        return this.$moment(this.fechaVencimientoProducto).format('YYYY-MM-DD');
      }else{
        return this.$moment(date).format('YYYY-MM-DD');
      }
    },
    limpiarFecha(){
      this.fechaVencimientoProducto = null;
    }
  }
};
</script>

<style>
.espacio {
  margin-bottom: 15px;
}
.separar {
  margin-right: 15px;
}
.input-requerido::placeholder {
  color: red;
  opacity: 0.7;
}
.table-encabezados-min {
  width: 5%;
}
.table-encabezados-max {
  width: 30%;
}
.actualizar {
  margin-top: 35px;
  margin-left: 12px;
  padding-left: 12px;
}
.noactualizar {
  margin-top: 0px;
  margin-left: 0px;
  padding-left: 0px;
}
.searcher-result{
  padding: 2px 0px 2px 0px;
  cursor: pointer;
    }
.searcher-field {
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 500px;
  } 
.input-placedark::placeholder {
    color: #353333;
    opacity: 0.9;
  } 
.input-dark {
    color: #000000;
    opacity: 1;
  }
  .colorTitulo{
    padding-left: 1%;
    border-radius: 8px;
    background-color:#7DC4CA;
  }
  .resultados-scroll {
    position: absolute;
    top: 100%; /* Justo debajo del input */
    left: 0;
    width: 100%;
    max-height: 500px; /* Ajusta según necesites */
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: white;
    z-index: 999; /* Se asegura de estar encima de otros elementos */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }
  .item-select {
    cursor: pointer; /* Cambia el cursor al pasar el mouse */
    transition: background 0.3s ease;
  }
  .item-select:hover {
    background-color: #f0f0f0; /* Efecto hover */
  }
  .imagen-lista {
    width: 50px;          
    height: 50px;         
    object-fit: cover;    
    border-radius: 5px;   
    margin-right: 10px;
  }
</style>


